/* eslint-disable */

import VueMeta from 'vue-meta';
import Router from 'vue-router';
import routes from './routes';

Vue.use(Router);
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
});

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return null;
    } else if (savedPosition === null) {
      return null;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (['developers', 'about', 'promo', 'developers-welcome', 'not-found'].includes(to.name)) {
    next();
  }
});

router.afterEach((routeTo, routeFrom) => {

});

export default router;
